import React, {useState, useEffect} from 'react';
import { AppBar, Toolbar, Typography, Box, MenuItem, IconButton, Menu, Avatar, Button } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { useNavigate, useLocation } from "react-router-dom";
//import { config } from '../config';
import { SessionManager, 
          sessionService, 
          LoggerUtility, 
          EnumUtility, 
          ConfirmationDialog, 
          ApiManager,
          DeterminePermissions,
          DeterminePermissions2
        } from '../components/ComponentsLibrary';

import { useConfigContext } from '../functions/ConfigContext';

import { useNavigationContext } from '../functions/NavigationContext';
import { ClientType } from "../enums/ClientType.js"
import { Info} from '@mui/icons-material';
import { Close } from '@mui/icons-material';
import { Error } from '@mui/icons-material';


  const defaultPermissionsForFields = {
    btnAskPriya: { read: false, write: false, hide: true },
    btnNext: { read: false, write: false, hide: false },
    btnNew: { read: false, write: false, hide: false },
    btnQueue: { read: false, write: false, hide: false },
    btnMyYTrac: { read: false, write: false, hide: true },
    btnCompleted: { read: false, write: false, hide: false },
    btnView: { read: false, write: false, hide: false },
    btnNewWorkflow: { read: false, write: false, hide: false },
    btnNewCallChat: { read: false, write: false, hide: false },
    btnNewWalkIn: { read: false, write: false, hide: false },
    btnNewDocument: { read: false, write: false, hide: false },
    btnQueueWorkflow: { read: false, write: false, hide: false },
    btnQueueLegal: { read: false, write: false, hide: false },
    btnQueueWalkIn: { read: false, write: false, hide: false },
    btnMyYTracSystemInfo: { read: false, write: false, hide: false },
    btnMyYTracMyProfile: { read: false, write: false, hide: false },
    btnMyYTracStats: { read: false, write: false, hide: false },
    btnMyYTracAwards: { read: false, write: false, hide: false },
    btnCompletedWorkflow: { read: false, write: false, hide: false },
    btnCompletedQA: { read: false, write: false, hide: false },
    btnCompletedVariance: { read: false, write: false, hide: false },
    btnReporting: { read: false, write: false, hide: false },
    btnAdmin: { read: false, write: false, hide: false },
    btnLegal: { read: false, write: false, hide: false },
    btnViewDocument: { read: false, write: false, hide: false },
    btnViewCase: { read: false, write: false, hide: false },
    btnViewContacts: { read: false, write: false, hide: false }
  };

const CustomAppBar = ({ handleProfileMenuOpen, anchorElProfile, handleProfileMenuClose, toggleDrawer, onAdminClick, onNewClick }) => {

  const loginStateSiteName = sessionService.LoginUserInfo ? (sessionService.LoginUserInfo.stateName + " | " + sessionService.LoginUserInfo.siteName) : "";
  const loginUserName = sessionService.LoginUserInfo ? (sessionService.LoginUserInfo.firstName + "  " + sessionService.LoginUserInfo.lastName) : "";
  const loginEmail = sessionService.LoginUserInfo ? (sessionService.LoginUserInfo.userName) : "";
  const [loginState, setLoginState] = useState("");
  const myYTrac = "My Y-Trac";
  // Default state dropdown value to be set on component load
  const defaultLoginStateValue = "wyoming"; // wyoming is set as default value here


  const errorFormName = "App Bar";

  const { configLibrary } = useConfigContext();
  const navigate = useNavigate();
  const location = useLocation();

  const { activePage, setActivePage, isFormContentChanged, setIsFormContentChanged, dialogContent } = useNavigationContext();
  const [targetPathID, setTargetPathID] = useState('');

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmationDialogContent, setConfirmationDialogContent] = useState([]);
  const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);

  const hasAskPriyaAccess =
    formFieldAccess.btnAskPriya?.write === true &&
    formFieldAccess.btnAskPriya?.hide === false;
  const isViewCasePage =
    location.pathname.toLowerCase().replace(/\/+$/, '') === '/caseview';
  const showAskPriya = hasAskPriyaAccess && isViewCasePage;


  const _appBarUserInfo = sessionService.getUser();
  const _appBarRoleID = _appBarUserInfo?.roleID;
  const _isRestrictedRole = _appBarRoleID === 9 || _appBarRoleID === 12;
  const canSeeCompleted =
    !_isRestrictedRole &&
    !(formFieldAccess.btnNext?.hide ?? false) &&
    !(formFieldAccess.btnNew?.hide ?? false) &&
    !(formFieldAccess.btnCompleted?.hide ?? false);

  console.log('[Completed Visibility Debug]', {
    userInfo: _appBarUserInfo,
    roleID: _appBarRoleID,
    isRestrictedRole: _isRestrictedRole,
    btnNext_hide: formFieldAccess.btnNext?.hide,
    btnNew_hide: formFieldAccess.btnNew?.hide,
    btnCompleted_hide: formFieldAccess.btnCompleted?.hide,
    canSeeCompleted,
  });

  let hostedEnvironment = configLibrary.hostedEnvironment;


useEffect(() => {
  const currentPath = window.location.pathname;
  console.log(currentPath, activePage, "ACTIVE PAGE")
}, []);
  
  useEffect(() => {
      // 🔍 UPDATED: Read permissions from session (set by SiteSelector)
      const userPermissions = SessionManager.GetDataFromSession("UserPermissions");
      
      if (userPermissions) {
          console.log('🔍 AppBar reading permissions from session:', userPermissions);
          setFormFieldAccess(userPermissions);
      } else {
          console.log('🔍 AppBar no permissions in session, using defaults');
          setFormFieldAccess(defaultPermissionsForFields);
      }
  }, []);

  // 🔍 ADD: Listen for session changes
  useEffect(() => {
      const handleStorageChange = () => {
          const userPermissions = SessionManager.GetDataFromSession("UserPermissions");
          if (userPermissions) {
              setFormFieldAccess(userPermissions);
          }
      };

      window.addEventListener('storage', handleStorageChange);
      return () => window.removeEventListener('storage', handleStorageChange);
  }, []);


  const goToSiteSelection = () => {
    if (sessionService.LoginUserInfo) {
      sessionService.updateUser({ checkSiteChange: true });
    }

    SessionManager.SetSession(SessionManager.CurrentActivePageKey, "/siteselect");
    // Navigate to a different path
    navigate('/siteselect', { replace: true });

    // Reload the page
    window.location.reload();
  };

  const goToNewDocument = () => {
    setActivePage('newDocument');
    SessionManager.SetSession(SessionManager.CurrentActivePageKey, "/newdocument");
    navigate('./newdocument'); // Redirects to the NewDocument component
    // Reload the page
    window.location.reload();
    handleNewMenuClose();
  };

  const goToDocumentSearch = () => {
    setActivePage('viewMenu');
    SessionManager.SetSession(SessionManager.CurrentActivePageKey, "/documentsearch");
    navigate('./documentsearch'); // Redirects to the DocumentSearch component
    handleViewMenuClose();
  };

  
  const goToNewWorkitem = () => {
    setActivePage('newWorkitem');
     SessionManager.SetSession(SessionManager.CurrentActivePageKey, ClientType.DropdownCategoryType.NewWorkItem);
    navigate('./newWorkitem'); // Redirects to the New Workitem component
  };

  const goToNextWorkitem = () => {
    setActivePage('nextWorkitem');
    SessionManager.SetSession(SessionManager.CurrentActivePageKey, ClientType.DropdownCategoryType.NextWorkItem);
    navigate('./nextWorkitem'); // Redirects to the Next Workitem component
  };

  const goToQueueWorkflow = () => {
    setActivePage('queueWorkflow');
    SessionManager.SetSession(SessionManager.CurrentActivePageKey, '/queueworkflow');
    navigate('./queueWorkflow'); // Redirects to the queueWorkflow component
  };

  const goToMyYTrac = () => {
    setActivePage('myytrac');
    navigate('./myytrac'); // Redirects to the myytrac component
  };

  const handleUserMenuMyYTracClick = () => {
    handleProfileMenuClose();
    handleMenuClick(EnumUtility.NavigationMenuType.MyYTrac.ID);
  };

  const handleUserMenuLogoutClick = () => {
    handleProfileMenuClose();
    handleMenuClick(EnumUtility.NavigationMenuType.LogOut.ID);
  };

   const goToCaseView= () => {
    setActivePage('caseView');
    SessionManager.SetSession(SessionManager.CurrentActivePageKey, ClientType.DropdownCategoryType.Case_View);
    navigate('./caseView'); // Redirects to the Case View component
  };

  // Completed does not have a page yet. Keep a no-op handler so the button is clickable but does not navigate.
  const goToCompleted = () => {
    setActivePage('completed');
    navigate('./completed'); // Redirects to the completed component
  };

  const goToNewWalkIn = () => {
    setActivePage('newwalkin');
    navigate('./newwalkin'); // Redirects to the new walk-in component
  };

   // State for the Main menu
   const [mainMenuAnchorEl, setMainMenuAnchorEl] = useState(null);
   const openMainMenu = Boolean(mainMenuAnchorEl);

   // State for the NEW sub-menu
   const [newMenuAnchorEl, setNewMenuAnchorEl] = useState(null);
   const openNewMenu = Boolean(newMenuAnchorEl);
 
   // State for the View sub-menu
   const [viewMenuAnchorEl, setViewMenuAnchorEl] = useState(null);
   const openViewMenu = Boolean(viewMenuAnchorEl);

    const [exclamationMenuAnchorEl, setExclamationMenuAnchorEl] = useState(null);
    const openExclamationMenu = Boolean(exclamationMenuAnchorEl);

    const handleInfoClose = () => {
        setExclamationMenuAnchorEl(null);
    };

    const handleExclamationMenuClose = () => {
        setExclamationMenuAnchorEl(null);
    };


  const logOut = () => {
    // debugger;
    sessionStorage.removeItem('token');
    SessionManager.ClearSession();
    window.location.replace("/");
    //window.location.replace(configLibrary.b2cUrl);
    //window.open(config.b2cUrl, "_self");
  }

  
  const handleStateChange = (e) => {
    SessionManager.ClearSession();   
    navigate('./newdocument', { replace: true }); // Redirects to the NewDocument component
    // Reload the page
    window.location.reload();    
    setLoginState(e.target.value);
    SessionManager.SetSession(SessionManager.LoginStateKey, e.target.value);

  };

  const handleNavigateUser = async (e) => {
    try {

    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, "App Menu Bar", "handleNavigateUser");
    }
  }

  const NavigateToTargetPath = async (targetPathID) => {
    try {
      switch (targetPathID) {
        case EnumUtility.NavigationMenuType.SiteSelection.ID:
          goToSiteSelection();
          break;

        case EnumUtility.NavigationMenuType.LogOut.ID:
          logOut();
          break;

        case EnumUtility.NavigationMenuType.NewDocumentIndex.ID:
          goToNewDocument();
          break;

        case EnumUtility.NavigationMenuType.DocumentSearch.ID:
          goToDocumentSearch();
          break;
        
        case EnumUtility.NavigationMenuType.CaseView.ID:
          goToCaseView();
          break;

        case EnumUtility.NavigationMenuType.MyYTrac.ID:
          goToMyYTrac();
          break;

        case EnumUtility.NavigationMenuType.NewWorkItem.ID:
          goToNewWorkitem();
          setNewMenuAnchorEl(null);
          break;

        case EnumUtility.NavigationMenuType.NextWorkItem.ID:
          goToNextWorkitem();
          break;

        case EnumUtility.NavigationMenuType.QueueWorkflow.ID:
          goToQueueWorkflow();
          break;

        case EnumUtility.NavigationMenuType.Completed.ID:
          goToCompleted();
          break;
        
        case EnumUtility.NavigationMenuType.NewWalkIn.ID:
          goToNewWalkIn();
          break;
        
        default:
          console.warn(`Unknown navigation path ID: ${targetPathID}`);
          break;
      };
    }
    catch (error) {
      await LoggerUtility.ProcessErrorData(error, "NavigateToTargetPath", {});
    }
  };

  const handleMenuClick = async (targetPathID) => {
    try {
      setTargetPathID(targetPathID);

      if (isFormContentChanged) {
        handleConfirmationDialog(dialogContent);
      }
      else {
        await NavigateToTargetPath(targetPathID);
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, "App Menu Bar", "handleMenuClick");
    }
  }

  // Handle main menu open
  const handleMainMenuOpen = (event) => {
    setMainMenuAnchorEl(event.currentTarget);
  };

  // Handle main menu close
  const handleMainMenuClose = () => {
    setMainMenuAnchorEl(null);
    setViewMenuAnchorEl(null); // Close View Menu as well
  };

  // Handle NEW menu open on mouse enter
  const handleNewMenuOpen = (event) => {
    setNewMenuAnchorEl(event.currentTarget);
  };

  // Handle NEW menu close on mouse leave
  const handleNewMenuClose = () => {
    setNewMenuAnchorEl(null);
  };

  // Handle View menu open on mouse enter
  const handleViewMenuOpen = (event) => {
    setViewMenuAnchorEl(event.currentTarget);
  };

  // Handle View menu close on mouse leave
  const handleViewMenuClose = () => {
    setViewMenuAnchorEl(null);
  };

  const handleConfirmationDialog = (dialogContent) => {
    setConfirmationDialogContent(dialogContent);
    handleOpenConfirmDialog();
  };

  const handleOpenConfirmDialog = () => {
    setConfirmDialogOpen(true);
  };

  const handleCloseConfirmDialog = () => {
    setConfirmDialogOpen(false);
    setMainMenuAnchorEl(null);
    setViewMenuAnchorEl(null);
  };

  const handleDialogConfirmAction = async () => {
    try {
      NavigateToTargetPath(targetPathID);
      setIsFormContentChanged(false);
      setConfirmDialogOpen(false);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDialogConfirmAction");
    }
  };

    const handleInformationClick = () => {
    console.log('Information clicked');
    // Your information logic here
  };

  // Add timer state for delayed closing
const [hoverTimer, setHoverTimer] = useState(null);

// Handle mouse enter on icon
const handleExclamationMenuOpen = (event) => {
    if (hoverTimer) {
        clearTimeout(hoverTimer);
        setHoverTimer(null);
    }
    setExclamationMenuAnchorEl(event.currentTarget);
};

// Handle mouse leave from icon
const handleExclamationMenuLeave = () => {
    const timer = setTimeout(() => {
        setExclamationMenuAnchorEl(null);
    }, 3000); // 300ms delay before closing
    setHoverTimer(timer);
};

// Handle mouse enter on menu
const handleMenuMouseEnter = () => {
    if (hoverTimer) {
        clearTimeout(hoverTimer);
        setHoverTimer(null);
    }
};

// Handle mouse leave from menu
const handleMenuMouseLeave = () => {
    const timer = setTimeout(() => {
        setExclamationMenuAnchorEl(null);
    }, 100); // Shorter delay for menu
    setHoverTimer(timer);
};

const handleExclamationIconClick = () => {
    // Close any open menus first
    setExclamationMenuAnchorEl(null);
    // Navigate to MyYTrac
    handleMenuClick(EnumUtility.NavigationMenuType.MyYTrac.ID);
};

// Enhanced handler
const handleExclamationIconClickWithTabPriority = (event) => {

    event.stopPropagation(); // Prevent event bubbling
    event.preventDefault();  // Prevent default behavior

    // Clear any hover-related state immediately
    setExclamationMenuAnchorEl(null);
    if (hoverTimer) {
        clearTimeout(hoverTimer);
        setHoverTimer(null);
    }
    
    SessionManager.SetSession('MyYTracDefaultTab', 'systeminfo');
    handleMenuClick(EnumUtility.NavigationMenuType.MyYTrac.ID);
};

const [versionRowData, setVersionRowData] = useState(null);

const handleVersionInformationOnly = async () => {
        try {
            const loginUserInfo = sessionService.getUser();
            const legacyUserInfo = sessionService.getLegacyUserID();
            const params = {
                UserLoginID:  legacyUserInfo,
                UserInfoID: loginUserInfo?.userInfoID,
                YTracSiteID: loginUserInfo?.siteID,
            };
            
            const systemInformationData = await ApiManager.GetSystemInformationFromAPI(params);
            
            // Original gridDataVersionInformationOnly structure (keeping for reference)
        const originalGridDataVersionInformationOnly  = Object.entries(systemInformationData).flatMap(([key, value], entryIndex) => {
            const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
            const arrayValue = stringValue.split(',').map(item => item.trim()).filter(item => item.length > 0);
            
            // Create a row for each value in the array
            return arrayValue.map((singleValue, arrayIndex) => {
                // Split the value by double quote followed by colon (":)
                const quoteColonSplit = singleValue.split('":').map(part => part.trim()).filter(part => part.length > 0);
                
                const twoDimensionalValue = quoteColonSplit.length > 1 ? quoteColonSplit : [singleValue];
                
                return {
                    id: `${entryIndex}-${arrayIndex}`, // Unique ID combining entry index and array index
                    item: arrayValue.length > 1 ? `${key.replace(/([A-Z])/g, ' $1').trim()} (${arrayIndex + 1})` : key.replace(/([A-Z])/g, ' $1').trim(),
                    value: singleValue,
                    valueParts: twoDimensionalValue, // 2D array split by quote+colon (":")
                    
                    valueArray: arrayValue, // Original comma-split array
                    originalKey: key,
                    arrayIndex: arrayIndex,
                    totalItems: arrayValue.length
                };
            });
        });

        // New gridDataVersionInformationOnly structure using valueParts with item = valueParts[0] and value = valueParts[1]
        const gridDataVersionInformationOnly  = Object.entries(systemInformationData).flatMap(([key, value], entryIndex) => {
            const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
            const arrayValue = stringValue.split(',').map(item => item.trim()).filter(item => item.length > 0);
            
            // Create a row for each value in the array
            return arrayValue.map((singleValue, arrayIndex) => {

                const quoteColonSplit = singleValue.split('":').map(part => {
                    return part.trim()
                        .replace(/^"|"$/g, '')     // Remove leading/trailing quotes
                        .replace(/^\{"/g, '')      // Remove opening brace + quote at start
                        .replace(/"\}$/g, '');     // Remove closing quote + brace at end
                }).filter(part => part.length > 0);

                const twoDimensionalValue = quoteColonSplit.length > 1 ? quoteColonSplit : [singleValue];
                
                return {
                    id: `${entryIndex}-${arrayIndex}`,
                    item: (twoDimensionalValue[0] || '')
                        .replace(/\\n/g, '\n')           // Convert \n to actual newlines
                        .replace(/^display_/i, '')       // Remove "display_" at the beginning (case insensitive)
                        .replace(/info/i, '')            // Remove "info" anywhere (case insensitive)
                        .replace(/\bRole\b/i, 'Security Role') // Replace "Role" with "Security Role" (whole word only)
                        .replace(/\bSessionHost\b/i, 'Session Host')  // Replace "SessionHost" with "Session Host"
                        .replace(/\bQueueList\b/i, 'Queue Assignments')   // Replace "QueueList" with "Queue Assignments"
                        .replace(/\bStateSite\b/i, 'State & Selected Site')  // Replace "StateSite" with "State & Selected Site"
                        .replace(/\bVersionReleaseData\b/i, 'Application Versions & Release Dates'),   // Replace "VersionReleaseData" with "Application Versions & Release Dates"
                    value: (twoDimensionalValue[1] || '').replace(/\\n/g, '\n'), // Convert \n to actual newlines
                    //value: originalKey === 'SessionHost' ? getSessionHost() : (twoDimensionalValue[1] || '').replace(/\\n/g, '\n'),
                    valueParts: twoDimensionalValue.map(part => part.replace(/\\n/g, '\n')),
                    valueArray: arrayValue, // Original comma-split array
                    originalKey: key,
                    arrayIndex: arrayIndex,
                    totalItems: arrayValue.length
                };
            });
        });

        // After processing the grid data
        const versionOnlyRows = gridDataVersionInformationOnly.filter(
            row => row.item === 'Application Versions & Release Dates' ||
                  row.originalKey === 'VersionReleaseData' ||
                  row.originalKey.toLowerCase().includes('version') ||
                  row.originalKey.toLowerCase().includes('release') 
        );

        let reactVersionReleaseNumber;
        const extractedVersion = extractVersionFromRows(versionOnlyRows);
        if (extractedVersion) {
            setDisplayVersion(extractedVersion);
        }
        // Parse back to 2D array
        const twoDimensionalArray = extractedVersion
            .split('\n')
            .map(line => line.split('|'));   
            
        // Find row containing React Front-End
        const reactRow = twoDimensionalArray.find(row => 
            Array.isArray(row) && row.some(cell => 
                cell && cell.toString().includes("React Front-End")
            )
        );   
        
         if (reactRow) {
            // Get the specific cell with React Front-End data
            const reactCell = reactRow.find(cell => 
                cell && cell.toString().includes("React Front-End")
            );
            
            if (reactCell) {
                // Try to extract version number
                const versionMatch = reactCell.match(/(\d+\.\d+[\.\d]*)/);
                if (versionMatch[1]) {
            setDisplayVersion(versionMatch[1]);
            reactVersionReleaseNumber = versionMatch[1];
        }

            }
        }

        SessionManager.SetSession('PreloadedVersionData', reactVersionReleaseNumber);    
        
      } catch (error) {
            console.error('Error loading version info:', error);
            // Still navigate but let MyYTrac handle the error
            //setActivePage('myytrac');
            //navigate('./myytrac');
        }
    };

const handleVersionClick = () => {
        setExclamationMenuAnchorEl(null);
        if (hoverTimer) clearTimeout(hoverTimer);
        // Set session flags for version-only mode
        SessionManager.SetSession('MyYTracVersionOnlyMode', true);
        SessionManager.SetSession('MyYTracDefaultTab', 'systeminfo');

        handleVersionInformationOnly();
    };

    const extractVersionFromRows = (versionOnlyRows) => {
    try {
        if (!versionOnlyRows || versionOnlyRows.length === 0) {
            return null;
        }
        
        // Look for the main version row
        const versionRow = versionOnlyRows.find(row => 
            row.originalKey === 'VersionReleaseData' ||
            row.item === 'Application Versions & Release Dates'
        ) || versionOnlyRows[0]; // Fallback to first row
        
        const versionText = versionRow.value || versionRow.item || '';
        return versionText;

    } catch (error) {
        console.error('Error extracting version from rows:', error);
        return null;
    }
};

    const [displayVersion, setDisplayVersion] = useState("245.175.1");

useEffect(() => {
    // Call handleVersionInformationOnly first to populate PreloadedVersionData
    const loadVersionData = async () => {
        await handleVersionInformationOnly();
      
    const preloadedVersionData = SessionManager.GetDataFromSession("PreloadedVersionData");
    if (preloadedVersionData) {
        const versionOnlyRows = JSON.parse(preloadedVersionData);
        const extractedVersion = extractVersionFromRows(versionOnlyRows);
        if (extractedVersion) {
            setDisplayVersion(extractedVersion);
        }
    }
        };
    
    loadVersionData();
}, []);


  return (
    <AppBar position="fixed" className="appBar" sx={{
      bgcolor: '#131e42'
    }}>
      <Toolbar className="container-fluid container-fluid-menu">

        <img src={require('../ywicon.png')} alt="logo" width={50} height={50} className='me-1'></img>
        <Typography variant="h6" noWrap sx={{ fontWeight: 400, fontSize: '2.00rem' }}>Y-Trac</Typography>

        <Box sx={{ display: 'flex', ml: 2, alignItems: 'center' }}>
          {/* 🔍 ADDED: Conditional rendering based on permissions */}
  
          {!(formFieldAccess.btnNext?.hide ?? false) && (
            <Button
              id="btnNext"
              name="btnNext"
              onClick={() => handleMenuClick(EnumUtility.NavigationMenuType.NextWorkItem.ID)}
              color="inherit"
              className={`yt-menu-button ${activePage === 'nextWorkitem' ? 'yt-menu-highlight' : ''}`}
              disabled={!(formFieldAccess.btnNext?.write ?? true)} // Disable if no write permission
            >
              Next
            </Button>
          )}
          {!(formFieldAccess.btnNew?.hide ?? false) && (
            <Button
              onClick={handleNewMenuOpen}
              color="inherit"
              className={`yt-menu-button ${(activePage === 'newDocument' || activePage === 'newWorkitem') ? 'yt-menu-highlight' : ''}`}
              aria-controls="new-menu"
              aria-haspopup="true"
              disabled={!(formFieldAccess.btnNew?.write ?? true)} // 🔍 ADD: Disable if no write permission
            >
              New <KeyboardArrowDown />
            </Button>
          )}
          {!(formFieldAccess.btnNew?.hide ?? false) && (
          <Menu
            id="new-menu"
            anchorEl={newMenuAnchorEl}
            open={openNewMenu}
            onClose={handleNewMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            {!(formFieldAccess.btnNewWorkflow?.hide ?? false) && (
              <MenuItem 
                onClick={() => { setNewMenuAnchorEl(null); handleMenuClick(EnumUtility.NavigationMenuType.NewWorkItem.ID); }}
                disabled={!(formFieldAccess.btnNewWorkflow?.write ?? true)}
              >
                New Work Item
              </MenuItem>
            )}
            {!(formFieldAccess.btnNewCallChat?.hide ?? false) && (
              <MenuItem disabled={!(formFieldAccess.btnNewCallChat?.write ?? true)}>
                New Call/Chat
              </MenuItem>
            )}
            {!(formFieldAccess.btnNewWalkIn?.hide ?? false) && (
                <MenuItem
                  onClick={() => { setNewMenuAnchorEl(null); handleMenuClick(EnumUtility.NavigationMenuType.NewWalkIn.ID); }}
                  disabled={!(formFieldAccess.btnNewWalkIn?.write ?? true)}>
                New Walk-In
              </MenuItem>
            )}
            {!(formFieldAccess.btnNewDocument?.hide ?? false) && (
              <MenuItem 
                onClick={() => handleMenuClick(EnumUtility.NavigationMenuType.NewDocumentIndex.ID)}
                disabled={!(formFieldAccess.btnNewDocument?.write ?? true)}
              >
                New Document
              </MenuItem>
            )}
          </Menu>
          )}
          {!(formFieldAccess.btnView?.hide ?? false) && (
          <Button
            onClick={handleViewMenuOpen}
            color="inherit"
            className={`yt-menu-button ${(activePage === 'viewMenu' || activePage === 'caseView') ? 'yt-menu-highlight' : ''}`}
            aria-controls="view-menu"
            aria-haspopup="true"
          >
            View <KeyboardArrowDown />
          </Button>
          )}
          <Menu
            id="view-menu"
            anchorEl={viewMenuAnchorEl}
            open={openViewMenu}
            onClose={handleViewMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            {!(formFieldAccess.btnViewDocument?.hide ?? false) && (
              <MenuItem 
                onClick={() => handleMenuClick(EnumUtility.NavigationMenuType.DocumentSearch.ID)}
                disabled={!(formFieldAccess.btnViewDocument?.write ?? true)}
              >
                Document(s)
              </MenuItem>
            )}
            {!(formFieldAccess.btnViewCase?.hide ?? false) && (
              <MenuItem
                onClick={() => { setViewMenuAnchorEl(null); handleMenuClick(EnumUtility.NavigationMenuType.CaseView.ID); }}
                disabled={!(formFieldAccess.btnViewCase?.write ?? true)}>
                Case
              </MenuItem>
            )}
            {!(formFieldAccess.btnViewContacts?.hide ?? false) && (
              <MenuItem disabled={!(formFieldAccess.btnViewContacts?.write ?? true)}>
                Contact(s)
              </MenuItem>
            )}
          </Menu>
          {!(formFieldAccess.btnQueue?.hide ?? false) && (
          <Button
            onClick={goToQueueWorkflow}
            disabled={!(formFieldAccess.btnNext?.write ?? true) && !(formFieldAccess.btnNewWorkflow?.write ?? true)}
            color="inherit"
            className={`yt-menu-button ${activePage === 'queueWorkflow' ? 'yt-menu-highlight' : ''}`}
          >
            Queue <KeyboardArrowDown />
          </Button>
          )}
          {canSeeCompleted && (
          <Button
            color="inherit"
            className={`yt-menu-button ${activePage === 'completed' ? 'yt-menu-highlight' : ''}`}
            onClick={() => handleMenuClick(EnumUtility.NavigationMenuType.Completed.ID)}
          >
            Completed <KeyboardArrowDown />
          </Button>
          )}
          {!(formFieldAccess.btnReporting?.hide ?? false) && (
            <Button
              color="inherit"
              className={`yt-menu-button`}
              disabled={!(formFieldAccess.btnReporting?.write ?? true)}
            >
              Reporting <KeyboardArrowDown />
            </Button>
          )}

          {!(formFieldAccess.btnAdmin?.hide ?? false) && (
            <Button
              color="inherit"
              className={`yt-menu-button`}
              disabled={!(formFieldAccess.btnAdmin?.write ?? true)}
            >
              Admin
            </Button>
          )}

          {!(formFieldAccess.btnLegal?.hide ?? false) && (
            <Button
              color="inherit"
              className={`yt-menu-button`}
              disabled={!(formFieldAccess.btnLegal?.write ?? true)}
            >
              Legal
            </Button>
          )}
        
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        <button onClick={() => handleMenuClick(EnumUtility.NavigationMenuType.SiteSelection.ID)} className="state-button">
          {hostedEnvironment && loginStateSiteName ? `${hostedEnvironment} | ${loginStateSiteName}` : loginStateSiteName || hostedEnvironment}
        </button>
        {showAskPriya && (
          <Box
            component="img"
            src="/images/AskPriyaIcon.svg"
            alt="askPriya"
            sx={{ width: 141, height: 40, ml: 2, flexShrink: 0 }}
          />
        )}
{/* 
        <Select className="state-dropdown" value={loginState} disableUnderline
          IconComponent={KeyboardArrowDown}
          onChange={handleStateChange}
          sx={{
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent", // Remove the border color
            },
            "&.MuiSelect-root.Mui-focused": {
              outline: "none", // Remove the outline around the select
            },
          }}>
          <MenuItem value="wyoming">Wyoming || Casper</MenuItem>
          <MenuItem value="zzstate">ZZ State || ZZ City</MenuItem>
          <MenuItem value="colorado">Colorado || Boulder</MenuItem>
        </Select> */} 

{/*<IconButton className="systemInfoIcon-menu-yt" size="large" onClick={handleProfileMenuOpen}><SystemInfoIcon alt="User1" /></IconButton>*/}
        
        

      <Box sx={{ width: '16px' }} /> {/* Spacer */}
      <IconButton 
    className="exclamation-menu-yt" 
    size="large"
    onClick={handleExclamationIconClickWithTabPriority} // HIGHEST PRIORITY
    onClickCapture={handleExclamationIconClickWithTabPriority} // Capture phase - highest priority
    onMouseEnter={handleExclamationMenuOpen} // Change from onClick to onMouseEnter
    onMouseLeave={handleExclamationMenuLeave} // Add mouse leave handler
    sx={{ 
        width: '40px',
        height: '40px',  
        backgroundColor: '#5A73EA',  // Blue background
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }}
    disableRipple={true}
    disableFocusRipple={true}
>
    <Typography 
        sx={{ 
            fontSize: '32px', 
            fontWeight: 'bold', 
            color: '#212F6E',
            lineHeight: 1
        }}
    >
        i
    </Typography>
</IconButton>
<Menu
          id="exclamation-menu" // Changed ID
          anchorEl={exclamationMenuAnchorEl} // Changed anchor state
          open={openExclamationMenu} // Changed open state
          onClose={handleExclamationMenuClose} // Changed close handler

          MenuListProps={{
            onMouseEnter: handleMenuMouseEnter, // Keep menu open when hovering over it
            onMouseLeave: handleMenuMouseLeave  // Close menu when leaving
          }}

          anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
          }}
          transformOrigin={{
              vertical: "top",
              horizontal: "right",
          }}

          PaperProps={{
          sx: {
            minWidth: 400, // Increase from default
            maxWidth: 600,

            minHeight: 150, // Increase from default
            maxHeight: 300,
            bgcolor: '#131E42', // Dark background
            color: '#E5BB8C', // Light text color
            '& .MuiMenuItem-root': {
                padding: '16px 20px', // Increase padding
                fontSize: '16px', // Keep your existing font size
                fontFamily: 'Noir Pro, Regular', // Keep your existing font
                minHeight: '56px' // Increase item height
            }
          }
        }}
      >

      {/* Header with title and close button */}
        <MenuItem sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              borderBottom: '1px solid rgba(229, 187, 140, 0.3)',
              marginBottom: '4px',
              color: '#FFFFFF',
              fontFamily: 'Noir Pro, Regular',
              fontSize: '18'
          }}>
        <span>System Information</span>
        <IconButton 
            size="small" 
            onClick={handleExclamationMenuClose}
            sx={{ p: 0.5, color: '#FFFFFF' }}
        >
            <Close fontSize="small" />
        </IconButton>
        </MenuItem>

     <MenuItem 
            className="yt-siteselect-version"
            onClick={handleVersionClick}
            style={{
                color: '#E5BB8C',
                fontFamily: 'Noir Pro, Regular',
                fontSize: '18',
                cursor: 'pointer' // Add cursor pointer to indicate it's clickable
            }}
        >
            Version: {displayVersion}
        </MenuItem>
          <MenuItem 
          
          onClick={() => handleMenuClick(EnumUtility.NavigationMenuType.MyYTrac.ID)}
            style={{
                color: '#5A73EA',
                fontFamily: 'Noir Pro, Regular',
                fontSize: '18',
                textAlign: 'right',
                display: 'flex',
                justifyContent: 'flex-end',
                paddingRight: '24px', // Add some right padding if needed
                cursor: 'pointer', // Show pointer cursor
                transition: 'all 0.3s ease', // Smooth transitions
                textDecoration: 'none' // Remove default link underline
            }}
            sx={{
              '&:hover': {
                color: '#5A73EA'
              }
            }}
          >
            <span>MORE</span>
            <span style={{ marginLeft: '16px' }}
            sx={{
              '&:hover': {
                color: '#5A73EA'
              }
            }}
            >{'>'}</span>
            </MenuItem>
        </Menu>
        
        <Box sx={{ width: '16px' }} /> {/* Spacer */}

        <IconButton className="avatar-menu-yt" size="large" onClick={handleProfileMenuOpen}
                    sx={{ 
              width: '36px',
              height: '36px',
              backgroundColor: 'transparent',
              border: 'none',
              borderRadius: 0, // Remove border radius if needed
              padding: 0, // Remove padding that might create spacing
            }}
          >

          <Avatar alt="User" /></IconButton>

        <Menu anchorEl={anchorElProfile} open={Boolean(anchorElProfile)} onClose={handleProfileMenuClose}>
          {loginUserName && <MenuItem>{loginUserName}</MenuItem>}
          {loginEmail && <MenuItem>{loginEmail}</MenuItem>}
          <MenuItem onClick={handleUserMenuMyYTracClick}>My Y-Trac</MenuItem>
          {/* userData && <MenuItem>{userData?.firstName}&nbsp;{userData?.userName}</MenuItem> */}
          {/* <MenuItem onClick={handleProfileMenuClose}>Change Profile</MenuItem> */}
          <MenuItem onClick={handleUserMenuLogoutClick}>Logout</MenuItem>
        </Menu>


      </Toolbar>

      {/* Include the Confirmation Dialog component */}
      <ConfirmationDialog
        openConfirmation={confirmDialogOpen}
        dialogContent={confirmationDialogContent}
        onCloseConfirmation={handleCloseConfirmDialog}
        onConfirmDialog={handleDialogConfirmAction}
      />

    </AppBar>
  );
};

export default CustomAppBar;
